// Project
export const READ = 'READ'
export const FETCH_NOTIFICATIONS = 'FETCH_NOTIFICATIONS'



// WEBPACK FOOTER //
// ./src/store/modules/Notifications/types.js